import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function ProblemSolutionSection() {
  return <section className="py-20 bg-white" data-id="element-490">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-491">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-492">
          <div data-id="element-493">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-8" data-id="element-494">
              Stop Hauling. Start Spraying.
            </h2>
            <div className="space-y-8" data-id="element-495">
              <div className="border-l-4 border-red-500 pl-6" data-id="element-496">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-497">
                  The Old Way
                </h3>
                <ul className="space-y-2 text-gray-600" data-id="element-498">
                  <li className="flex items-start" data-id="element-499">
                    <span className="mr-2 text-red-500" data-id="element-500">✕</span> Carrying heavy
                    chemicals into attics & crawlspaces
                  </li>
                  <li className="flex items-start" data-id="element-501">
                    <span className="mr-2 text-red-500" data-id="element-502">✕</span> Pouring into
                    backpacks or small tanks
                  </li>
                  <li className="flex items-start" data-id="element-503">
                    <span className="mr-2 text-red-500" data-id="element-504">✕</span> Battery
                    failures and expensive downtime
                  </li>
                </ul>
              </div>

              <div className="border-l-4 border-brand-yellow pl-6" data-id="element-505">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-506">
                  The ForceX Way
                </h3>
                <ul className="space-y-2 text-gray-600" data-id="element-507">
                  <li className="flex items-start" data-id="element-508">
                    <CheckCircle2 className="h-5 w-5 text-brand-yellow mr-2 mt-0.5" data-id="element-509" />{' '}
                    External container siphon - leave the heavy lifting behind
                  </li>
                  <li className="flex items-start" data-id="element-510">
                    <CheckCircle2 className="h-5 w-5 text-brand-yellow mr-2 mt-0.5" data-id="element-511" />{' '}
                    Corded reliability - never run out of power
                  </li>
                  <li className="flex items-start" data-id="element-512">
                    <CheckCircle2 className="h-5 w-5 text-brand-yellow mr-2 mt-0.5" data-id="element-513" />{' '}
                    Fast setup, controlled spray, automatic shutoff
                  </li>
                </ul>
              </div>
            </div>
            <div className="mt-8" data-id="element-514">
              <a href="#kits" className="inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 uppercase tracking-wide bg-brand-yellow text-brand-dark hover:bg-yellow-400 focus:ring-brand-yellow h-11 px-6 text-base" data-id="element-515">
                Upgrade Your Setup
              </a>
            </div>
          </div>
          <div className="relative h-96 rounded-lg overflow-hidden" data-id="element-516">
            <img src="https://cdn.magicpatterns.com/uploads/o6LcpLcnE3tYBY2tteo4MD/old-way.png" alt="Contractor pouring chemicals into backpack sprayer" className="w-full h-full object-cover" style={{
            objectPosition: '65% center',
            filter: 'brightness(0.88) saturate(0.85)'
          }} data-id="element-517" />
            <div className="absolute inset-0 bg-black/12" data-id="element-518"></div>
            <div className="absolute bottom-4 right-4 text-white/40 text-xs uppercase tracking-wider font-bold" data-id="element-519">
              The Old Way
            </div>
          </div>
        </div>
      </div>
    </section>;
}